import { DebouncedField } from '@ui/components/DebouncedField';
import { actions } from '@ui/features/quote-builder/state/reducer';
import { selectSnapRequirementField } from '@ui/features/quote-builder/state/selectors/snap-requirement-field';
import { EditableQuoteBuilderRequirementField } from '@ui/features/quote-builder/types/state/requirement';
import { useDispatch } from '@ui/hooks/useDispatch';
import { useSelector } from '@ui/hooks/useSelector';

type RequirementCellProps = {
  quoteLineUuid: string;
  snapOperationUuid: string;
  snapRequirementUuid: string;
  field: EditableQuoteBuilderRequirementField;
};

export function RequirementCell({
  quoteLineUuid,
  snapOperationUuid,
  snapRequirementUuid,
  field,
}: RequirementCellProps) {
  const { value, issues, elementId } = useSelector((state) =>
    selectSnapRequirementField(
      state,
      quoteLineUuid,
      snapOperationUuid,
      snapRequirementUuid,
      field,
    ),
  );
  const dispatch = useDispatch();

  const onChange = (value: string) => {
    dispatch(
      actions.requirementValueChanged({
        quoteLineUuid,
        snapOperationUuid,
        snapRequirementUuid,
        value,
        field,
      }),
    );
  };

  return (
    <DebouncedField
      id={elementId}
      value={value}
      onChange={onChange}
      isInvalid={issues.length > 0}
      error={issues[0]?.description}
      errorSeverity={issues[0]?.severity}
    />
  );
}
